import styles from "./WlpThemeShell.module.scss";

function WlpThemeShell({ children }: { children: React.ReactNode }) {
  return <div className={styles.shell}>{children}</div>;
}

export { WlpThemeShell };

